// Central SEO configuration for A Girl's Girl (AGG).
// Update SITE_URL to the production custom domain at launch (or set REACT_APP_SITE_URL).

export const SITE_URL =
  process.env.REACT_APP_SITE_URL ||
  (typeof window !== "undefined" && window.location && window.location.origin) ||
  "https://thrive-lead.preview.emergentagent.com";

export const SITE_NAME = "A Girl's Girl (AGG)";

// High-resolution, authentic homepage hero used as the default social preview image.
export const DEFAULT_OG_IMAGE =
  "https://customer-assets.emergentagent.com/job_0e489a82-2f44-4016-bd13-c06ced2d5c32/artifacts/mb5jp0g8_AGG%20GIRLS%20PICTURE%20WITH%20BRANDED%20SHIRT.png";

export const DEFAULT_DESCRIPTION =
  "A Girl's Girl (AGG) equips girls with the confidence to thrive and the skills to lead through confidence development, mentorship, leadership training, wellness education, and life readiness programming. Partner with us to empower the next generation of confident young women.";

// Per-route metadata. Titles stay under ~60 chars, descriptions under ~160 where possible.
export const PAGE_SEO = {
  "/": {
    title: "A Girl's Girl (AGG) | Where Confidence Meets Life Readiness",
    description: DEFAULT_DESCRIPTION,
    keywords:
      "girls leadership program, confidence building for girls, life readiness for girls, mentorship for girls, girls empowerment, girls nonprofit, Charlotte nonprofit, North Carolina nonprofit",
  },
  "/about": {
    title: "About A Girl's Girl (AGG) | Our Mission to Empower Girls",
    description:
      "Learn how A Girl's Girl (AGG) builds confident, future-ready girls through transformational programming, mentorship, leadership development, and supportive sisterhood in Charlotte, North Carolina.",
    keywords:
      "about A Girl's Girl, girls empowerment nonprofit, Charlotte girls organization, youth leadership, girls mentorship",
  },
  "/founder": {
    title: "Meet the Founder | Cherelle Hawkins-Frazier — A Girl's Girl",
    description:
      "Meet Cherelle Hawkins-Frazier, founder of A Girl's Girl (AGG), and discover the vision behind a movement equipping girls with confidence, leadership, and life readiness.",
    keywords:
      "Cherelle Hawkins-Frazier, A Girl's Girl founder, girls nonprofit founder, women leadership Charlotte",
  },
  "/programs": {
    title: "Our Programs | Confidence, Wellness & Life Readiness for Girls",
    description:
      "Explore AGG's signature programs—SHE BELIEVES, SHE GROWS, and SHE LEADS—offering confidence development, wellness education, leadership, and life readiness for middle and high school girls.",
    keywords:
      "girls leadership program, confidence building for girls, life readiness, middle school girls programs, high school girls programs, college readiness, entrepreneurship for girls",
  },
  "/who-we-serve": {
    title: "Who We Serve | Schools, Group Homes & Communities — AGG",
    description:
      "A Girl's Girl partners with schools, group homes, foster care programs, churches, and community youth organizations across Charlotte and North Carolina to bring transformational programming to girls.",
    keywords:
      "group home programming, foster care support, community youth organization, schools girls programs, church youth programs, Mecklenburg County nonprofit",
  },
  "/partners": {
    title: "Partner With AGG | Bring Confidence & Leadership to Your Girls",
    description:
      "Partner with A Girl's Girl to bring confidence, mentorship, and life readiness programming to the girls your school, group home, church, or community organization serves.",
    keywords:
      "partner girls nonprofit, school partnership girls program, corporate sponsorship girls, community partnership Charlotte",
  },
  "/mentor": {
    title: "Become a Mentor | Guide the Next Generation — A Girl's Girl",
    description:
      "Become an AGG mentor and walk alongside girls as they build confidence, leadership, and life readiness. Share your experience and help shape future-ready young women.",
    keywords:
      "mentorship for girls, become a mentor, women mentors Charlotte, volunteer mentor girls nonprofit",
  },
  "/volunteer": {
    title: "Volunteer With AGG | Empower Girls in Your Community",
    description:
      "Volunteer with A Girl's Girl and help create safe, supportive spaces where girls grow into confident, compassionate leaders across Charlotte and North Carolina.",
    keywords:
      "volunteer girls nonprofit, Charlotte volunteer opportunities, youth volunteer North Carolina, girls empowerment volunteer",
  },
  "/donate": {
    title: "Donate to A Girl's Girl | Invest in Confident, Future-Ready Girls",
    description:
      "Your gift to A Girl's Girl (AGG) funds confidence development, mentorship, wellness, and life readiness programming for girls. Donate today to empower the next generation.",
    keywords:
      "donate girls nonprofit, support girls empowerment, Charlotte nonprofit donation, fund girls leadership",
  },
  "/events": {
    title: "Events | Workshops & Experiences for Girls — A Girl's Girl",
    description:
      "Discover upcoming A Girl's Girl events, workshops, and experiences designed to build confidence, leadership, and life readiness for girls and their communities.",
    keywords:
      "girls workshops Charlotte, youth leadership events, girls empowerment events North Carolina",
  },
  "/impact": {
    title: "Our Impact Pillars | The Difference AGG Makes",
    description:
      "See the difference A Girl's Girl makes through our core pillars: confidence development, leadership, life readiness, mentorship, emotional wellness, community partnerships, and safe spaces.",
    keywords:
      "girls empowerment impact, confidence development, leadership development, life readiness, mentorship for girls",
  },
  "/contact": {
    title: "Contact A Girl's Girl (AGG) | Connect With Our Team",
    description:
      "Get in touch with A Girl's Girl (AGG). Whether you're a school, group home, church, donor, volunteer, or parent in Charlotte and North Carolina, we'd love to connect.",
    keywords:
      "contact A Girl's Girl, Charlotte girls nonprofit contact, partner with girls organization",
  },
  "/admin": {
    title: "Admin | A Girl's Girl",
    description: "Administrative access for A Girl's Girl staff.",
    noindex: true,
  },
  "/shop": {
    title: "AGG Shop | Wear the Mission — A Girl's Girl",
    description:
      "Shop A Girl's Girl merchandise and wear the mission. Every purchase invests in confidence, leadership, and life readiness for the next generation of young women.",
    keywords:
      "A Girl's Girl shop, AGG merchandise, nonprofit merchandise, girls empowerment apparel, shop with purpose, mission merchandise",
  },
  "/ways-to-give": {
    title: "Ways to Give | Support A Girl's Girl",
    description:
      "Discover every way to support A Girl's Girl—one-time gifts, monthly giving, corporate sponsorship, shopping with purpose, volunteering, and mentorship. Invest in confident, future-ready girls.",
    keywords:
      "ways to give girls nonprofit, donate, monthly giving, corporate sponsorship girls, sponsor a girl, support girls empowerment Charlotte",
  },
  "/schools": {
    title: "For Schools & Organizations | Partner With A Girl's Girl",
    description:
      "A Girl's Girl partners with schools, group homes, foster care agencies, churches, and community organizations to deliver confidence, leadership, and life-readiness programming for girls.",
    keywords:
      "school partnership girls program, group home programming, foster care support, church youth programs, community partnership Charlotte, book girls workshop",
  },
};

export function getPageSeo(pathname) {
  return PAGE_SEO[pathname] || PAGE_SEO["/"];
}
